export default function (date) {
  console.log(date);

  const months = ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
  const dateParts = date.split('-');
  const year = dateParts[0];
  const day = dateParts[2][0] === '0' ? dateParts[2][1] : dateParts[2].substring(0, 2);
  const month = months[parseInt(dateParts[1], 10) - 1];

  return `${month} ${day}, ${year}`;
}
